import { z } from "zod";
import { Sha256HexSchema } from "./primitives.js";

export const ServerKindSchema = z.enum(["designed", "naive-baseline"]);
export type ServerKind = z.infer<typeof ServerKindSchema>;

export const ServerFileSchema = z.object({
  path: z.string().min(1),
  content: z.string(),
  /** sha256 of the content so downstream stages can refer without re-hashing. */
  digest: Sha256HexSchema
});
export type ServerFile = z.infer<typeof ServerFileSchema>;

export const ServerArtifactSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  kind: ServerKindSchema,
  serverName: z.string().min(1),
  serverVersion: z.string().min(1),
  files: z.array(ServerFileSchema).min(1),
  /** sha256 of the canonical concatenation of file digests; deterministic per inputs. */
  digest: Sha256HexSchema,
  generatedAt: z.string().datetime({ offset: true })
});
export type ServerArtifact = z.infer<typeof ServerArtifactSchema>;
